import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-protocolo-page',
  templateUrl: './protocolo-page.component.html'
})
export class ProtocoloPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
